// ANGULAR
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// MODELS
import { APIUrl } from '@models/api-url.model';
import { Backup } from '@models/backups.model';
// STORE
import { Store } from '@ngrx/store';
import { MainState } from '@store/main.reducer';
import { selectRefreshToken, selectToken } from '@store/session/session.selectors';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  private configLocal: any = {};
  private apiUrlLocal: APIUrl = { name: '', url: '' };

  private tokenLocal: string | null = null;
  private refreshTokenLocal: string | null = null;

  // Variable para controlar si se ha pulsado el botón de iniciar edición para controlar que mensaje a mostrar al pulsar ver modo edición
  private pressStartEditingButtonLocal: boolean = false;

  readonly editModeDisabledMsg: string = 'El Oráculo no está en modo edición';
  private editingLocal: boolean = false;

  private backupToPreviewLocal: Backup | null = null;

  constructor(
    private store: Store<MainState>,
    private http: HttpClient
  ) {
    this.store.select(selectToken).subscribe(token => this.tokenLocal = token);
    this.store.select(selectRefreshToken).subscribe(refreshToken => this.refreshTokenLocal = refreshToken);
  }

  loadConfig(): Promise<any> { 
    return firstValueFrom(this.http.get('/assets/config.json')).then(data => this.configLocal = data); 
  }

  async loadAPIUrl(): Promise<APIUrl> {
    // Cargar configuración en tiempo de ejecución
    await this.loadConfig();
    // Usar la URL cargada dinámicamente
    this.apiUrlLocal = { name: 'Por defecto', url: this.configLocal.apiUrl };

    return this.apiUrlLocal;
  }

  get apiUrl(): APIUrl { return this.apiUrlLocal;}
  setApiUrl(apiUrl: APIUrl): void { this.apiUrlLocal = apiUrl; }

  get token(): string | null { return this.tokenLocal; }
  get refreshToken(): string | null { return this.refreshTokenLocal; }

  get pressStartEditingButton(): boolean { return this.pressStartEditingButtonLocal; }
  setPressStartEditingButton(pressStartEditingButton: boolean) {
    this.pressStartEditingButtonLocal = pressStartEditingButton;
  }

  get editing(): boolean { return this.editingLocal; }
  setEditing(editing: boolean): void {
    this.editingLocal = !!this.backupToPreviewLocal ? false : editing;
  }

  get backupToPreview(): Backup | null { return this.backupToPreviewLocal; }
  setBackupToPreview(backup: Backup | null): void {
    this.backupToPreviewLocal = backup;
  }
}